import { Link } from "react-router-dom";
import { ArrowLeft, FileArrowDown } from "@phosphor-icons/react";
import { WHITEPAPER_V1 } from "@/config/whitepaperV1";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { ChapterTag } from "@/components/site/primitives";

const Block = ({ section, index }) => (
  <section id={`wp-${section.id}`} className="scroll-mt-28" data-testid={`wp-section-${section.id}`}>
    <div className="flex items-baseline gap-4">
      <span className="font-mono text-xs text-gold tracking-[0.2em]">{String(index + 1).padStart(2, "0")}</span>
      <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-mist">{section.title}</h2>
    </div>
    <div className="mt-5 space-y-4">
      {section.paragraphs?.map((p, i) => (
        <p key={i} className="text-sm sm:text-base text-slate leading-relaxed">{p}</p>
      ))}
      {section.list && (
        <ul className="space-y-2.5">
          {section.list.map((item, i) => (
            <li key={i} className="flex items-start gap-3 text-sm sm:text-base text-slate leading-relaxed">
              <span className="mt-[9px] h-1.5 w-1.5 rounded-full bg-teal shrink-0" aria-hidden="true" />
              {item}
            </li>
          ))}
        </ul>
      )}
      {section.table && (
        <div className="card-surface rounded-lg overflow-hidden divide-y divide-line">
          {section.table.map(([k, v]) => (
            <div key={k} className="flex flex-col sm:flex-row sm:items-center justify-between gap-1 sm:gap-6 px-5 sm:px-6 py-3.5">
              <span className="font-mono text-[11px] tracking-[0.15em] uppercase text-slate">{k}</span>
              <span className={`font-mono text-xs sm:text-sm sm:text-right ${k === "Maximum Supply" || k === "Total" ? "text-gold font-semibold" : "text-mist"}`}>{v}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  </section>
);

const WhitepaperPage = () => (
  <div className="bg-navy min-h-screen" data-testid="whitepaper-page">
    <Navbar />
    <main className="section-shell pt-32 pb-24">
      <div className="max-w-6xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.2em] uppercase text-slate hover:text-teal transition-colors duration-300" data-testid="wp-back-link">
          <ArrowLeft size={16} /> Back to site
        </Link>

        <header className="mt-10 border-b border-line pb-12">
          <ChapterTag index="WP" label="Official Document" />
          <h1 className="mt-6 font-display font-bold tracking-tight text-4xl sm:text-5xl lg:text-6xl text-mist" data-testid="wp-title">
            Jovino Coin <span className="text-teal">White Paper</span>
          </h1>
          <div className="mt-5 flex flex-wrap items-center gap-4">
            <span className="font-mono text-sm text-gold tracking-[0.2em]">VERSION {WHITEPAPER_V1.version}</span>
            <span className="text-slate">•</span>
            <span className="font-mono text-sm text-slate tracking-[0.15em] uppercase">{WHITEPAPER_V1.title}</span>
          </div>
          <a
            href="/JCV-Whitepaper-v1.0.pdf"
            download
            data-testid="wp-download-button"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-teal px-7 py-3 font-display font-semibold text-sm text-navy transition-transform duration-300 hover:scale-[1.03]"
          >
            <FileArrowDown size={18} /> Download PDF
          </a>
        </header>

        <div className="mt-12 grid gap-12 lg:grid-cols-[220px_1fr]">
          <aside className="hidden lg:block">
            <nav className="sticky top-28 space-y-2" aria-label="White paper contents">
              {WHITEPAPER_V1.sections.map((s, i) => (
                <button
                  key={s.id}
                  onClick={() => window.dispatchEvent(new CustomEvent("jcv:scroll", { detail: `#wp-${s.id}` }))}
                  className="block w-full text-left font-mono text-[11px] tracking-wide text-slate hover:text-teal transition-colors duration-300"
                  data-testid={`wp-toc-${s.id}`}
                >
                  <span className="text-gold/70 mr-2">{String(i + 1).padStart(2, "0")}</span>
                  {s.title}
                </button>
              ))}
            </nav>
          </aside>
          <article className="space-y-16 max-w-3xl">
            {WHITEPAPER_V1.sections.map((s, i) => (
              <Block key={s.id} section={s} index={i} />
            ))}
          </article>
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default WhitepaperPage;
